import { getDate } from './utils';
export const ASSET_VISIBLE_COLUMNS = [
    'id',
    'serial',
    'name',
    'model',
    'category',
    'assignee',
    'location',
    'creationDate',
    'region',
    'groupId',
    'groupName',
    'comment',
    'tags',
];
export const SORTED_FILED = {
    id: 'creationDate',
    header: 'Creation date',
    cell: (e) => getDate(e.creationDate),
    sortingField: 'creationDate',
    width: 300,
};
export const ASSET_COLUMNS_DEFINITION = [
    {
        id: 'id',
        header: 'UUID',
        cell: (e) => e.id,
        sortingField: 'id',
        width: 350,
    },
    {
        id: 'serial',
        header: 'Serial',
        cell: (e) => e.serial,
        sortingField: 'serial',
        width: 200,
    },
    {
        id: 'location',
        header: 'Location',
        cell: (e) => e.location,
        sortingField: 'location',
        width: 200,
    },
    {
        id: 'name',
        header: 'Asset name',
        cell: (e) => e.name,
        sortingField: 'name',
        width: 200,
    },
    {
        id: 'model',
        header: 'Model',
        cell: (e) => e.model,
        sortingField: 'model',
        width: 200,
    },
    {
        id: 'category',
        header: 'Category',
        cell: (e) => e.category,
        sortingField: 'category',
        width: 200,
    },
    {
        id: 'assignee',
        header: 'Assignee',
        cell: (e) => e.assignee,
        sortingField: 'assignee',
        width: 200,
    },
    SORTED_FILED,
    {
        id: 'region',
        header: 'Region',
        cell: (e) => e.region,
        sortingField: 'region',
        width: 200,
    },
    {
        id: 'groupId',
        header: 'Group id',
        cell: (e) => e.groupId,
        sortingField: 'groupId',
        width: 300,
    },
    {
        id: 'groupName',
        header: 'Group name',
        cell: (e) => e.groupName,
        sortingField: 'groupName',
        width: 250,
    },
    {
        id: 'comment',
        header: 'Comment',
        cell: (e) => e.comment,
        sortingField: 'comment',
        width: 250,
    },
    {
        id: 'tags',
        header: 'Tags',
        cell: (e) => e.tags,
        sortingField: 'tags',
        width: 400,
    },
];
export const LAPTOP = 'Laptop';
export const DESKTOP = 'Desktop';
export const ANDROID = 'Android';
export const IOS = 'IOS';
export const GATEWAY = 'Gateway';
export const SWITCH = 'Switch';
export const FIRETV = 'FireTV';
export const HEADLESS = 'Headless';
export const MULTIMODAL = 'Multimodal';
export const TABLET = 'Tablet';
export const OTHERS = 'Others';
export const CATEGORY_OPTIONS = [
    { label: LAPTOP, value: LAPTOP },
    { label: DESKTOP, value: DESKTOP },
    { label: ANDROID, value: ANDROID },
    { label: IOS, value: IOS },
    { label: GATEWAY, value: GATEWAY },
    { label: SWITCH, value: SWITCH },
    { label: FIRETV, value: FIRETV },
    { label: HEADLESS, value: HEADLESS },
    { label: MULTIMODAL, value: MULTIMODAL },
    { label: TABLET, value: TABLET },
    { label: OTHERS, value: OTHERS },
];

export const COLLECTION_PREFERENCES_PROPS = {
    pageSizePreference: {
        title: 'Select page size',
        options: [
            { value: 20, label: '20 assets' },
            { value: 50, label: '50 assets' },
            { value: 100, label: '100 assets' },
        ],
    },
    visibleContentPreference: {
        title: 'Select visible columns',
        options: [
            {
                label: 'Main properties',
                options: ASSET_COLUMNS_DEFINITION.map(({ id, header }) => ({
                    id,
                    label: header,
                    editable: id !== 'id',
                })),
            },
        ],
    },
    cancelLabel: 'Cancel',
    confirmLabel: 'Confirm',
    title: 'Preferences',
    stickyColumnsPreference: {
        firstColumns: {
            title: 'Freeze first column(s)',
            description: 'Keep the first column(s) visible while horizontally scrolling the table content.',
            options: [
                { label: 'None', value: 0 },
                { label: 'First column', value: 1 },
            ],
        },
    },
};

export const id = 'id';
